import { useState, useEffect } from "react";

function Clock() {
    
  const [time, setTime] = useState(new Date());

  useEffect(() => {

    const interval = setInterval(() => {
      setTime(new Date());
    }, 1000);

    return () => clearInterval(interval); // cleanup
  }, []);

  return <div>{time.toLocaleString()}</div>;
}

export default Clock;
